export default "__VITE_ASSET__c08VXhrr__"